// extracted by mini-css-extract-plugin
export default {"option":"creator-option_option__z6es-","icon":"creator-option_icon__+7UNj"};